export default __webpack_public_path__ + "static/media/undraw_team_spirit_hrr4.5342ef52.svg";